export function staffCommission(state = [], action) {
  switch (action.type) {
    case "STAFF_COMMISSION_FETCH":
      return action.data;

    default:
      return state;
  }
}
